import { useCallback, ReactElement } from "react";
import { useDispatch } from "react-redux";
import { notNil } from "@evergiving/common/dist/es2015/typescriptUtils";
import { MelissaAddressFieldConfig } from "@evergiving/common/dist/es2015/form";
import { MelissaPostalAddress } from "@evergiving/common/dist/es2015/pledge";

import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";
import { setPostalAddress } from "@/lib/redux/actions";

export function MelissaAddressField({
  melissaAddressFieldConfig,
  postalAddress,
  countryName,
}: {
  melissaAddressFieldConfig: MelissaAddressFieldConfig;
  postalAddress: MelissaPostalAddress;
  countryName: string | undefined;
}): ReactElement {
  const dispatch = useDispatch();
  const handleChangeAddress = useCallback(() => {
    dispatch(setPostalAddress(undefined));
  }, [dispatch]);

  const addressLineFields = [
    "Address1",
    "Address2",
    "Address3",
    "Address4",
    "Address5",
    "Address6",
    "Address7",
    "Address8",
    "Address9",
    "Address10",
    "Address11",
    "Address12",
  ] as (keyof MelissaPostalAddress)[];

  const fields = addressLineFields
    .map((field) => postalAddress[field])
    .filter(notNil)
    .filter((field) => String(field).length > 0)
    .concat(countryName === undefined ? [] : [countryName])
    .join("\n");

  return (
    <LabelledField id="billingAddress">
      <LabelText>{melissaAddressFieldConfig.labelText}</LabelText>
      <div className="addressFormatted">
        <div className="addressLines">{fields}</div>
        <div className="addressButtonContainer">
          <button
            type="button"
            onClick={handleChangeAddress}
            className="addressChangeButton"
          >
            {melissaAddressFieldConfig.changeAddressButtonText}
          </button>
        </div>
      </div>
    </LabelledField>
  );
}
